import xor from 'lodash/fp/xor';

import { UserMap } from './types';

export const xorUsers = (usersOne: UserMap, usersTwo: UserMap) =>
  xor(Object.keys(usersOne), Object.keys(usersTwo)).reduce<UserMap>((acc, item) => {
    acc[item] = usersOne[item] || usersTwo[item];
    return acc;
  }, {});
